import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "sticky-table-footer"
};
import { toRefs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ReportTotalRow',
    props: {
        headers: { default: () => [] },
        report: { default: () => { } }
    },
    setup(__props) {
        const props = __props;
        const { headers, report, } = toRefs(props);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tfoot", null, [
                (_unref(report))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (header, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (index === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: header.value + index
                                    }, " 총 "))
                                    : (!(header.total))
                                        ? (_openBlock(), _createElementBlock("td", {
                                            key: 'total' + header.value + index
                                        }))
                                        : (_openBlock(), _createElementBlock("td", {
                                            key: header.value + index,
                                            class: _normalizeClass(`td__${header.align}`)
                                        }, _toDisplayString(_unref(report).getTotalValueByKey(header.origin)), 3 /* TEXT, CLASS */))
                            ], 64 /* STABLE_FRAGMENT */));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
